module.exports = __webpack_public_path__ + "img/image-placeholder-icon.b5f6922b.jpg";